import { render, staticRenderFns } from "./ListSanBiao.vue?vue&type=template&id=0fa9bece&scoped=true"
import script from "./ListSanBiao.vue?vue&type=script&lang=js"
export * from "./ListSanBiao.vue?vue&type=script&lang=js"
import style0 from "./ListSanBiao.vue?vue&type=style&index=0&id=0fa9bece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa9bece",
  null
  
)

export default component.exports